/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<d2d4a0085e6b0fe33005d387c3be528a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Mutation } from "relay-runtime";
export type HelpCenterHelpDeskDeleteInput = {
  helpCenterAri: string;
  helpDeskId: string;
};
export type removeHelpDeskMutation$variables = {
  cloudId: string;
  input: HelpCenterHelpDeskDeleteInput;
};
export type removeHelpDeskMutation$data = {
  readonly helpCenter: {
    readonly deleteHelpDesk: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type removeHelpDeskMutation = {
  response: removeHelpDeskMutation$data;
  variables: removeHelpDeskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterHelpDeskPayload",
        "kind": "LinkedField",
        "name": "deleteHelpDesk",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeHelpDeskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeHelpDeskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7b897e9a9ba758d572459994016720a",
    "id": null,
    "metadata": {},
    "name": "removeHelpDeskMutation",
    "operationKind": "mutation",
    "text": "mutation removeHelpDeskMutation(\n  $cloudId: ID!\n  $input: HelpCenterHelpDeskDeleteInput!\n) {\n  helpCenter(cloudId: $cloudId) {\n    deleteHelpDesk(input: $input) {\n      success\n      errors {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f86ae6cc0962dc91922882c1f1370424";

export default node;
